import { render, staticRenderFns } from "./HorizontalHolder.vue?vue&type=template&id=09b3031e&scoped=true&"
import script from "./HorizontalHolder.vue?vue&type=script&setup=true&lang=js&"
export * from "./HorizontalHolder.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./HorizontalHolder.vue?vue&type=style&index=0&id=09b3031e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3031e",
  null
  
)

export default component.exports